import '../App.css';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function openNav() {
    document.getElementById("myNav").style.height = "100%";
    document.getElementById("hamMenu").style.opacity = "0";
}

function closeNav() {
    document.getElementById("myNav").style.height = "0%";
    document.getElementById("hamMenu").style.opacity = "1";
}
function optionClicked() {
    document.getElementById("myNav").style.height = "0%";
    document.getElementById("hamMenu").style.opacity = "1";
}

function Header({ navigateTo }) {
    const location = useLocation();

    return (
        <div className="HeaderWrapper">
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <header className="Header">
                <div className="headerDiv1">
                    <Link to="/" className={location.pathname === '/Homepage' ? 'TWA4 active' : 'TWA4'}>
                        <img src={require('./images/welleo_logo_full.png')} alt="Welleo Logo" />
                    </Link>
                </div>
                <div className="headerDiv2">
                    <Link to="/" className={location.pathname === '/Homepage' ? 'TWA active' : 'TWA'}>THE WELLEO APP</Link>
                    <div>
                        <Link to="/WorkAtWelleo" className={location.pathname === '/WorkAtWelleo' ? 'WAW active' : 'WAW'}>
                            <span className="TagTitle">WORK AT WELLEO <span className="tag">New</span></span>
                        </Link>
                    </div>
                    <Link to="/WeAreWelleo" className={location.pathname === '/WeAreWelleo' ? 'WRW active' : 'WRW'}>WE ARE WELLEO</Link>
                    <Link to="/SignUp" className={location.pathname === '/SignUp' ? 'SignUpButton active' : 'SignUpButton'}>SIGN UP</Link>
                    <span id="hamMenu" className="HamburgerButton" onClick={() => openNav()}>&#9776;</span>
                </div>
            </header>
            <div id="myNav" className="overlay2">
                <button href="#" className="closebtn" onClick={(event) => { event.preventDefault(); closeNav(); }}>&times;</button>
                <div className="overlay2-content">
                    <Link to="/" className="TWA2" onClick={() => optionClicked()}>THE WELLEO APP</Link>
                    <Link to="/WorkAtWelleo" className="WAW2" onClick={() => optionClicked()}>WORK AT WELLEO</Link>
                    <Link to="/WeAreWelleo" className="WRW2" onClick={() => optionClicked()}>WE ARE WELLEO</Link>
                    <Link to="/SignUp" className="SignUpButton" onClick={() => optionClicked()}>SIGN UP</Link>
                </div>
            </div>
        </div>
    );
}

export default Header;
